export default __webpack_public_path__ + "static/media/1309.8b86e7ea.png";